// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkflowsIndexPage_wrapper__QbfOM","workflowCards":"WorkflowsIndexPage_workflowCards__9wAw+"};